export default "__VITE_ASSET__065c6c7c__"